// ======================================================
//  shop.js — Shopify Theme
//  ・カートドロワー（AJAX Cart API）
//  ・ヘッダースクロール制御
//  ・ショップイントロ（コレクションページ）
//  ・スクロールリビール
// ======================================================

(function () {
  'use strict';

  // ────────────────────────────────────────────────────
  //  ユーティリティ
  // ────────────────────────────────────────────────────
  function formatMoney(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  // ────────────────────────────────────────────────────
  //  AJAX Cart API
  // ────────────────────────────────────────────────────
  const CartAPI = {
    async get() {
      const r = await fetch(window.SHOPIFY_ROUTES.cartGet);
      return r.json();
    },
    async add(variantId, quantity = 1) {
      const r = await fetch(window.SHOPIFY_ROUTES.cartAdd, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity }),
      });
      if (!r.ok) throw new Error('cart/add.js error');
      return r.json();
    },
    async change(line, quantity) {
      const r = await fetch(window.SHOPIFY_ROUTES.cartChange, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ line, quantity }),
      });
      return r.json();
    },
  };

  // ────────────────────────────────────────────────────
  //  カートドロワー
  // ────────────────────────────────────────────────────
  const drawer    = document.getElementById('cart-drawer');
  const drawerBody = document.getElementById('cart-drawer-body');
  const drawerFoot = document.getElementById('cart-drawer-foot');
  const subtotalEl = document.getElementById('cart-subtotal-price');
  const countEl    = document.getElementById('cart-count');

  function updateCartCount(n) {
    if (!countEl) return;
    countEl.textContent = n;
    countEl.classList.toggle('cart-count--hidden', n === 0);
  }

  function renderCartItems(cart) {
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<p class="cart-empty-msg">カートは空です</p>';
      if (drawerFoot) drawerFoot.style.display = 'none';
      return;
    }

    drawerBody.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item">
        ${item.image
          ? `<img class="cart-item__image" src="${item.image}" alt="${item.product_title}">`
          : '<div class="cart-item__image"></div>'}
        <div>
          <p class="cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item__variant">${item.variant_title}</p>`
            : ''}
          <p class="cart-item__price">${formatMoney(item.price)}</p>
          <div class="cart-item__qty">
            <button class="qty-btn" data-line="${i + 1}" data-delta="-1">−</button>
            <span class="qty-value">${item.quantity}</span>
            <button class="qty-btn" data-line="${i + 1}" data-delta="1">+</button>
          </div>
          <button class="cart-item__remove" data-line="${i + 1}" data-delta="0">削除</button>
        </div>
      </div>
    `).join('');

    if (drawerFoot) {
      drawerFoot.style.display = 'block';
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  async function refreshDrawer() {
    const cart = await CartAPI.get();
    renderCartItems(cart);
    updateCartCount(cart.item_count);
    return cart;
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    refreshDrawer();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // カートドロワー開閉ボタン
  document.querySelectorAll('.js-cart-open').forEach(btn =>
    btn.addEventListener('click', openDrawer)
  );
  document.querySelectorAll('.js-cart-close').forEach(btn =>
    btn.addEventListener('click', closeDrawer)
  );
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeNav(); } });

  // ────────────────────────────────────────────────────
  //  ナビドロワー
  // ────────────────────────────────────────────────────
  const navDrawer = document.getElementById('nav-drawer');

  const menuToggleBtns = document.querySelectorAll('.js-menu-toggle');

  function openNav() {
    if (!navDrawer) return;
    navDrawer.classList.add('is-open');
    navDrawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    menuToggleBtns.forEach(btn => btn.classList.add('is-active'));
  }

  function closeNav() {
    if (!navDrawer) return;
    navDrawer.classList.remove('is-open');
    navDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    menuToggleBtns.forEach(btn => btn.classList.remove('is-active'));
  }

  menuToggleBtns.forEach(btn =>
    btn.addEventListener('click', () => btn.classList.contains('is-active') ? closeNav() : openNav())
  );
  document.querySelectorAll('.js-menu-close').forEach(el =>
    el.addEventListener('click', closeNav)
  );

  // 数量変更・削除（ドロワー内）
  drawerBody?.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line]');
    if (!btn) return;
    const line  = parseInt(btn.dataset.line, 10);
    const delta = parseInt(btn.dataset.delta, 10);
    const item  = drawerBody.querySelectorAll('.cart-item')[line - 1];
    const qtyEl = item?.querySelector('.qty-value');

    let newQty;
    if (delta === 0) {
      newQty = 0;
    } else {
      const current = parseInt(qtyEl?.textContent ?? '1', 10);
      newQty = Math.max(0, current + delta);
    }
    const cart = await CartAPI.change(line, newQty);
    renderCartItems(cart);
    updateCartCount(cart.item_count);
  });

  // 商品カードの「カートに追加」ボタン
  document.querySelectorAll('.js-card-add').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = parseInt(this.dataset.variantId, 10);
      if (!variantId) return;
      const orig = this.textContent;
      this.disabled    = true;
      this.textContent = '追加中…';
      try {
        await CartAPI.add(variantId, 1);
        openDrawer();
      } catch (e) {
        alert('カートへの追加に失敗しました。');
      } finally {
        this.disabled    = false;
        this.textContent = orig;
      }
    });
  });

  // グローバルに公開（product-main.liquid の inline script から使用）
  window.FukutoCart = { add: CartAPI.add, openDrawer, refreshDrawer };

  // ────────────────────────────────────────────────────
  //  HOME & LOCK ダウンロード
  // ────────────────────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.homelock__dl-btn');
    if (!btn) return;
    const src      = btn.dataset.src;
    const name     = btn.dataset.name || 'wallpaper.jpg';
    const origText = btn.textContent;
    btn.textContent = '取得中…';
    try {
      const res  = await fetch(src);
      const blob = await res.blob();
      // Web Share API（iOS: 写真に保存 / Android: ギャラリー保存が選択肢に出る）
      if (navigator.canShare) {
        const file = new File([blob], name, { type: blob.type });
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: name });
          btn.textContent = origText;
          return;
        }
      }
      // フォールバック: 通常ダウンロード
      const url = URL.createObjectURL(blob);
      const a   = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      if (err.name !== 'AbortError') alert('ダウンロードに失敗しました。');
    }
    btn.textContent = origText;
  });

  // ────────────────────────────────────────────────────
  //  スクロールリビール
  // ────────────────────────────────────────────────────
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  // ────────────────────────────────────────────────────
  //  ショップイントロ（コレクションページのみ）
  // ────────────────────────────────────────────────────
  const intro = document.getElementById('shop-intro');
  if (!intro) return; // コレクションページ以外は終了

  const scrollHint = document.getElementById('scroll-hint');
  function hideScrollHint() { if (scrollHint) scrollHint.classList.remove('is-visible'); }

  const layers = [
    document.getElementById('layer-1'),
    document.getElementById('layer-2'),
    document.getElementById('layer-3'),
  ];
  const hint   = document.getElementById('swipe-hint');
  const header = document.getElementById('site-header');

  document.body.classList.add('intro-active');

  // パララックス
  let targetX = 0, targetY = 0, currentX = 0, currentY = 0;
  const DEPTH = [5, 13, 22];

  // ドラッグ
  let touchStartY = 0, dragY = 0, isDragging = false, dismissed = false;

  function applyTransforms() {
    layers.forEach((el, i) => {
      if (!el) return;
      const px = currentX * DEPTH[i], py = currentY * DEPTH[i];
      let dx = 0, dy = 0;
      if      (i === 0) dx =  dragY;
      else if (i === 1) dx = -dragY;
      else              dy = -dragY;
      el.style.transform = `translate(calc(-50% + ${px + dx}px), calc(-50% + ${py + dy}px))`;
    });
  }

  (function raf() {
    if (!dismissed) {
      currentX += (targetX - currentX) * 0.06;
      currentY += (targetY - currentY) * 0.06;
      applyTransforms();
    }
    requestAnimationFrame(raf);
  })();

  // ジャイロ
  function onOrientation(e) {
    if (dismissed) return;
    targetX = Math.max(-1, Math.min(1, (e.gamma || 0) / 25));
    targetY = Math.max(-1, Math.min(1, ((e.beta || 45) - 45) / 25));
  }
  if (typeof DeviceOrientationEvent !== 'undefined' &&
      typeof DeviceOrientationEvent.requestPermission === 'function') {
    intro.addEventListener('touchstart', () => {
      DeviceOrientationEvent.requestPermission()
        .then(s => { if (s === 'granted') window.addEventListener('deviceorientation', onOrientation); })
        .catch(() => {});
    }, { once: true, passive: true });
  } else {
    window.addEventListener('deviceorientation', onOrientation);
  }

  // マウス
  window.addEventListener('mousemove', (e) => {
    if (dismissed) return;
    targetX = (e.clientX / window.innerWidth  - 0.5) * 2;
    targetY = (e.clientY / window.innerHeight - 0.5) * 2;
  });

  const group    = document.getElementById('disc-group');
  const logoWrap = document.getElementById('logo-wrap');
  const logo     = document.getElementById('logo');
  const textImg  = document.getElementById('text');
  const bird     = document.getElementById('bird');
  const trees   = ['tree01', 'tree02', 'tree03'].map(id => document.getElementById(id));
  let treesShown = false;

  // ── PC: 通常フロー + フェードイン ──────────────────
  if (window.innerWidth >= 768) {
    intro.style.display = 'none';
    document.body.classList.remove('intro-active');
    if (logoWrap) { logoWrap.classList.add('reveal'); revealObserver.observe(logoWrap); }
    ['text01', 'text02', 'text03', 'text-pc'].forEach(id => {
      const el = document.getElementById(id);
      if (el) { el.classList.add('reveal'); revealObserver.observe(el); }
    });

    const pcCorners = ['pc-left-top', 'pc-left-bottom', 'pc-right-top', 'pc-right-bottom']
      .map(id => document.getElementById(id));
    let cornersShown = false;

    window.addEventListener('scroll', () => {
      if (!header || !logo) return;
      if (logo.getBoundingClientRect().bottom <= 0) {
        header.classList.add('is-visible');
      } else {
        header.classList.remove('is-visible');
      }
      if (!cornersShown && window.scrollY > 120) {
        cornersShown = true;
        pcCorners.forEach(el => { if (el) el.classList.add('corner-visible'); });
      }
      if (window.scrollY > 30) hideScrollHint();
    }, { passive: true });
    setTimeout(function() { if (scrollHint) scrollHint.classList.add('is-visible'); }, 1200);
    return;
  }
  // ────────────────────────────────────────────────────

  // ── Mobile: SMP コーナー演出（intro/trees/bird は非表示）──
  intro.style.display = 'none';
  document.body.classList.remove('intro-active');
  dismissed = true;

  if (logo) logo.style.opacity = '1';
  setTimeout(function() { if (scrollHint) scrollHint.classList.add('is-visible'); }, 1200);

  const smpCorners = ['smp-left-bottom', 'smp-right-bottom', 'smp-top']
    .map(id => document.getElementById(id));
  let smpShown = false;

  window.addEventListener('scroll', () => {
    const y = window.scrollY;

    if (group)    group.style.transform    = `translate(-50%, calc(-50% - ${y}px))`;
    if (logoWrap) logoWrap.style.transform = `translate(-50%, calc(-50% - ${y}px))`;

    if (y > 30) hideScrollHint();

    if (!smpShown && y > 120) {
      smpShown = true;
      smpCorners.forEach(el => { if (el) el.classList.add('corner-visible'); });
      if (textImg) textImg.style.opacity = '1';
    }

    if (header && logo) {
      if (logo.getBoundingClientRect().bottom <= 0) {
        header.classList.add('is-visible');
      } else {
        header.classList.remove('is-visible');
      }
    }
  }, { passive: true });

})();
